import React from 'react'

const Analytics = () => {
  return (
    <h1>Coming Soon</h1>
  )
}

export default Analytics